<template>
  <div class="customer-noti-detail">
    <ul>
      <li>
        <span class="cus-list-btn">
            <span class="cus-preview">
                <span class="type">{{noticeInfo.noticetypetext}}</span>
                <strong>{{noticeInfo.noticetitle}}</strong>
                <span class="cus-list-date">{{noticeInfo.regdate}}</span>
            </span>
        </span>
        <span class="content" v-html="noticeContent">
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { CustomerService } from '@/common/api/api.service'
import { get } from 'lodash'
import { MOBILE_WEB_HOSTNAME } from '@/common/constant'

export default {
  name: 'CustomerNoticeView',
  components: {},
  data () {
    return {
      noticeid: '',
      noticeInfo: {},
      noticeContent: ''
    }
  },
  methods: {},
  created () {
    this.noticeid = get(this.$route, ['params', 'noticeid'], this.$route.query.noticeId)
    CustomerService.getNoticeDetail({ noticeid: this.noticeid }).then(({ data }) => {
      this.noticeInfo = data
      this.noticeContent = this.noticeInfo.content.replace(/www.wavve.com/gi, MOBILE_WEB_HOSTNAME)
    })
  }
}
</script>
